export default __webpack_public_path__ + "static/perfect-project-a38737e3bebd0dbad13dbab39ee8008f.jpg";